import classNames from 'classnames';

import Link from '~/shared/components/link/link';
import SocialLinks from '~/shared/components/social-links/social-links';
import { type Locale, PAGE_NAMES } from '~/shared/constants';
import { getLocaleLink } from '~/shared/helpers/browser-helpers';
import { getUrl } from '~/shared/helpers/string-helpers';
import { useTypedTranslation } from '~/shared/hooks';

import './additional-links.scss';

import pranaBgSvg from '~/assets/prana-bg.svg?url';

type AdditionalLinksType = Readonly<{
  onMobileMenuClose?: () => void;
  lng: Locale;
}>;

const AdditionalLinks = ({ lng, closeDropdown, onMobileMenuClose = () => {} }: AdditionalLinksType) => {
  const t = useTypedTranslation(['text', 'page', 'link']);

  return (
    <nav itemScope itemType="http://schema.org/SiteNavigationElement" className="additional-links__wrapper">
      <div className={classNames('container', 'additional-links__main-block')}>
        <div className="additional-links">
          <section className="additional-links__item">
            <div className="additional-links__title">{t('text.website-chapters')}:</div>
            <div className="additional-links__list">
              <div className="additional-links__list-column">
                <Link
                  itemProp="url"
                  onClick={() => {
                    closeDropdown && closeDropdown();
                    onMobileMenuClose && onMobileMenuClose();
                  }}
                  href={getLocaleLink(
                    getUrl({
                      link: PAGE_NAMES.ABOUT_US,
                    }),
                    lng,
                  )}
                >
                  <div className="additional-links__list-item">
                    <div className="additional-links__bullet"></div>
                    <div className="additional-links__text">{t('page.about-us.title')}</div>
                  </div>
                </Link>
                <Link
                  itemProp="url"
                  onClick={() => {
                    closeDropdown && closeDropdown();
                    onMobileMenuClose && onMobileMenuClose();
                  }}
                  href={`${getLocaleLink(
                    getUrl({
                      link: PAGE_NAMES.HOME,
                    }),
                    lng,
                  )}#our-goal`}
                >
                  <div className="additional-links__list-item">
                    <div className="additional-links__bullet"></div>
                    <div className="additional-links__text">{t('page.our-mission.title')}</div>
                  </div>
                </Link>
                <Link
                  itemProp="url"
                  onClick={() => {
                    closeDropdown && closeDropdown();
                    onMobileMenuClose && onMobileMenuClose();
                  }}
                  href={`${getLocaleLink(
                    getUrl({
                      link: PAGE_NAMES.HOME,
                    }),
                    lng,
                  )}#faq`}
                >
                  <div className="additional-links__list-item">
                    <div className="additional-links__bullet"></div>
                    <div className="additional-links__text">{t('page.faq.title')}</div>
                  </div>
                </Link>
                <Link
                  itemProp="url"
                  onClick={() => {
                    closeDropdown && closeDropdown();
                    onMobileMenuClose && onMobileMenuClose();
                  }}
                  href={getLocaleLink(
                    getUrl({
                      link: PAGE_NAMES.CONTACTS,
                    }),
                    lng,
                  )}
                >
                  <div className="additional-links__list-item">
                    <div className="additional-links__bullet"></div>
                    <div className="additional-links__text">{t('page.contacts.title')}</div>
                  </div>
                </Link>
              </div>
              <div className="additional-links__list-column">
                <Link
                  itemProp="url"
                  onClick={() => {
                    closeDropdown && closeDropdown();
                    onMobileMenuClose && onMobileMenuClose();
                  }}
                  href={PAGE_NAMES.OUR_STATUTE}
                >
                  <div className="additional-links__list-item">
                    <div className="additional-links__bullet"></div>
                    <div className="additional-links__text">{t('page.oferta.title')}</div>
                  </div>
                </Link>
                <Link
                  itemProp="url"
                  onClick={() => {
                    closeDropdown && closeDropdown();
                    onMobileMenuClose && onMobileMenuClose();
                  }}
                  href={PAGE_NAMES.PRIVACY_POLICY}
                >
                  <div className="additional-links__list-item">
                    <div className="additional-links__bullet"></div>
                    <div className="additional-links__text">{t('page.privacy-policy.title')}</div>
                  </div>
                </Link>
              </div>
            </div>
          </section>
          <section className="additional-links__item">
            <div className="additional-links__title">{t('text.topics')}:</div>
            <div className="additional-links__list">
              <div className="additional-links__list-column">
                <Link
                  itemProp="url"
                  onClick={() => {
                    closeDropdown && closeDropdown();
                    onMobileMenuClose && onMobileMenuClose();
                  }}
                  href={getLocaleLink(
                    getUrl({
                      link: PAGE_NAMES.BLOG,
                    }),
                    lng,
                  )}
                >
                  <div className="additional-links__list-item">
                    <div className="additional-links__bullet"></div>
                    <div className="additional-links__text">{t('page.blog.title')}</div>
                  </div>
                </Link>
                <Link
                  itemProp="url"
                  onClick={() => {
                    closeDropdown && closeDropdown();
                    onMobileMenuClose && onMobileMenuClose();
                  }}
                  href={getLocaleLink(
                    getUrl({
                      link: PAGE_NAMES.COURSES,
                    }),
                    lng,
                  )}
                >
                  <div className="additional-links__list-item">
                    <div className="additional-links__bullet"></div>
                    <div className="additional-links__text">{t('page.courses.title')}</div>
                  </div>
                </Link>
              </div>
            </div>
          </section>
          <section className="additional-links__item">
            <div className="additional-links__title">{t('text.social-networks')}:</div>
            <div className="additional-links__list">
              <div className="additional-links__list-column">
                <div className="additional-links__social-links">
                  <SocialLinks onClick={closeDropdown} />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <img src={pranaBgSvg} alt="" className="additional-links__bg" />
    </nav>
  );
};

export default AdditionalLinks;
